/**
 * features/tax-lookup/hooks.ts — ค้นข้อมูลผู้เสียภาษีจากกรมสรรพากร
 */

import { useMutation } from '@tanstack/react-query';
import { api } from '~/lib/api';
import type { TaxLookupResult } from '~/lib/types';

export function useTaxLookup() {
  return useMutation({
    mutationFn: (taxId: string) =>
      api.get<TaxLookupResult>(`/api/tax-lookup?taxId=${encodeURIComponent(taxId)}`),
  });
}
